export function menuBuilder(appId, appName, menuUrl) {
  let $appMenu = $('#menu-app-' + appId);

  axios.get(menuUrl, { withCredentials: true })
    .then(response => {
      let menuApp = {
        id: appId,
        name: appName,
        items: response.data
      }

      localStorage.setItem('app-' + appId, JSON.stringify(menuApp));

      _.forEach(response.data, function (itemList, key) {
        let $titleLi = $('<li/>').addClass('menu-app-title');
        let $title = $('<span/>').html(key).addClass('font-700');
        $titleLi.append($title);

        $appMenu.append($titleLi);

        _.forEach(itemList, function (menuItem) {
          let $aLi = $('<li/>').addClass('menu-app-item');
          let $a = $('<a/>').html(menuItem.name).attr('href', menuItem.url).attr('target', '_blank');
          $aLi.append($a)
          $appMenu.append($aLi);
        });
      });
    }).catch(function (error) {
    console.log(error);
  })

}
